import { getCookie } from "@insite/client-framework/Common/Cookies";
import { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
import { COOKIES } from "@store/constants";

export default () => {
    return getCookie(COOKIES.branchDistanceUom)?.toString() as DistanceUnitOfMeasure ?? "Imperial";
};
